<script>
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import {
  BaseAffiliateLinkElementMixin,
} from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/base-affiliate-link-element-mixin";

export default {
  name: "ProductLinkBrandName",
  elementPanelSettings: {
    displayName: "Brand Name",
    displayIcon: "text-alt",
    elementType: "element",
    elementGroup: "Product",
  },
  extends: UrlElement,
  mixins: [BaseAffiliateLinkElementMixin],
  computed: {
    label() {
      return this.entity.brandName;
    },
    computedHref() {
      return this.entity.affiliateLink;
    },
    shouldShowLink() {
      return !!this.label;
    },
  },
};
</script>
